// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as FlagOutlineComponent} from './FlagOutline.svg';

import Icon, { TIconProps } from '../Icon';

export const IconFlagOutline = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <FlagOutlineComponent/>
  </Icon>
));
